import { render } from "./TextInputStep.vue?vue&type=template&id=1c96b797&scoped=true"
import script from "./TextInputStep.vue?vue&type=script&lang=js"
export * from "./TextInputStep.vue?vue&type=script&lang=js"

import "./TextInputStep.vue?vue&type=style&index=0&id=1c96b797&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c96b797"

export default script